import { t } from "@lingui/core/macro";
import { createFileRoute } from "@tanstack/react-router";

import { formatCurrency } from "@/util/numberUtils";
import { cashSaleEligibility } from "@/util/withdrawalRules";

import {
  FlowTabs,
  HelpBlock,
  SaleAllocation,
  Screen,
  StepFooter,
  WarningBanner,
  useFlow,
  useFlowNavigate,
} from "../../-components/Withdrawal/WithdrawalFlow";

const CashSaleScreen = () => {
  const navigate = useFlowNavigate();
  const { inputs, cash, setCash } = useFlow();
  const eligibility = cashSaleEligibility({
    holdings: inputs.holdings,
    quantities: cash.quantities,
    ...inputs.limits,
  });

  return (
    <Screen subtitle={t`Choose what you want to sell`} step={{ index: 2, total: 4 }}>
      <FlowTabs value="cash" />

      <SaleAllocation
        holdings={inputs.holdings}
        quantities={cash.quantities}
        onQuantityChange={({ metal, value }) => setCash({ quantities: { ...cash.quantities, [metal]: value } })}
      />

      {eligibility.belowMinimum && (
        <WarningBanner>
          {t`Select at least ${formatCurrency(inputs.limits.minimum)}, or withdraw your full available balance if it is below the minimum.`}
        </WarningBanner>
      )}
      {eligibility.aboveMaximum && inputs.limits.maximum !== undefined && (
        <WarningBanner>
          {t`Reduce your sale to ${formatCurrency(inputs.limits.maximum)} or less. Contact Client Relations for a larger withdrawal.`}
        </WarningBanner>
      )}
      <StepFooter
        onBack={() => navigate("")}
        onContinue={() => navigate("cash/payout")}
        continueDisabled={!eligibility.allowed}
      />
      <HelpBlock />
    </Screen>
  );
};

export const Route = createFileRoute("/_authenticated/trade/withdraw/cash/")({
  component: CashSaleScreen,
});
